class AccessCardMembersAndGroups {
    constructor(form, modal, accessCardInfo = null) {
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.form = form;
        this.modal = modal;
        this.accessCardInfo = accessCardInfo;
        this.addMembersModal = accessCardInfo ?
            document.getElementById('add_members_to_edit_access_card_modal') :
            document.getElementById('add_members_to_create_access_card_modal');
        this.datatableEl = this.modal.querySelector('#members-and-groups-datatable');
        this.datatableIntance = null;

        this.initMembersDatatable();
    }
    initMembersDatatable(){
        const thisClass = this;

        /** Init Members/Groups datatable in access card modal */
        if(this.accessCardInfo){
            new AccessCardsMembersAndGroupsDatatable(this.form, this.modal, this.accessCardInfo.uuid, this.accessCardInfo.numberOfMembers,  this.accessCardInfo.numberOfGroups);
        } else {
            new AccessCardsMembersAndGroupsDatatable(this.form, this.modal);
        }
        /** After Members/Groups datatable in access card modal is initialized - do some action */
        $(thisClass.datatableEl).on( 'init.dt', function () {
            thisClass.datatableIntance = $(this).DataTable();
            let membersOrGroupsNotInAccessCard = thisClass.datatableIntance.rows('.not-in-access-card.d-none').data().toArray();

            /** If all members/groups is in access card - disable button for add members/groups to access card */
            let addMembersToAccessCardButton = thisClass.modal.querySelector('#addMembersToAccessCard');
            if(membersOrGroupsNotInAccessCard.length === 0){
                addMembersToAccessCardButton.setAttribute('disabled', 'true');
            }

            /** If user close add modal - show edit access card modal */
            $(thisClass.addMembersModal).on('hide.bs.modal', function () {
                bootstrap.Modal.getOrCreateInstance(thisClass.modal, {}).show();
            });

            /** Init add and remove actions from members */
            thisClass.initAddMembersOrGroupsToAccessCard(thisClass.datatableIntance);
            thisClass.removeMemberOrGroupFromAccessCard(thisClass.datatableIntance);

            /** Adjust datatable columns */
            thisClass.adjustDatatable(thisClass.datatableIntance);

            /** Init validation for add members/groups to datatable */
            thisClass.addMembersOrGroupToAccessCardFormValidation(thisClass.datatableIntance);
        });
    }
    adjustDatatable(datatable){
        /** Adjust datatable columns after modal is hidden */
        $(this.addMembersModal).on('hidden.bs.modal', function () {
            datatable.columns.adjust();
        });
    }
    initAddMembersOrGroupsToAccessCard(datatable){
        let thisClass = this;
        let addMembersToAccessCardButton = this.modal.querySelector('#addMembersToAccessCard');

        /** After click on add members/groups to access card */
        addMembersToAccessCardButton.addEventListener('click', function () {
            /** initialize tagify input for adding members/groups to access card */
            let membersOrGroupsNotInAccessCard = datatable.rows('.not-in-access-card.d-none').data().toArray();
            thisClass.initAddMembersOrGroupToAccessCardTagify(membersOrGroupsNotInAccessCard);

            /** Open add members or groups modal */
            bootstrap.Modal.getOrCreateInstance(thisClass.modal).hide();
            bootstrap.Modal.getOrCreateInstance(thisClass.addMembersModal, {}).show();
        });
    }
    initAddMembersOrGroupToAccessCardTagify(membersOrGroupsNotInAccessCard){
        const inputElm = this.addMembersModal.querySelector('input[name=membersOrGroupsToAdd]');
        /** Destroy tagify on input - we want new instance if tagify already exist */
        if(inputElm.__tagify){
            inputElm.value = '';
            inputElm.__tagify.destroy();
        }

        /** Adding values - tagify needs 'value' */
        for(let i in membersOrGroupsNotInAccessCard){
            membersOrGroupsNotInAccessCard[i]['value'] = membersOrGroupsNotInAccessCard[i]['uuid'];
        }
        /** Initialize tagify input for adding members or groups */
        new MembersGroupsTagify(inputElm, membersOrGroupsNotInAccessCard);
    }
    addMembersOrGroupToAccessCardFormValidation(datatable){
        let thisClass = this;
        let form = this.accessCardInfo ?
            document.getElementById('frm-addMembersOrGroupToEditAccessCardForm-addMembersOrGroupToEditAccessCardForm') :
            document.getElementById('frm-addMembersOrGroupToCreateAccessCardForm-addMembersOrGroupToCreateAccessCardForm');

        if(form){
            let submitButton = form.querySelector('.add-button');

            let validator = FormValidation.formValidation(
                form,
                {
                    fields: {
                        'membersOrGroupsToAdd': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                            }
                        },
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger(),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        }),
                    }
                }
            );

            const submitForm = (datatable) => {
                if (validator) {
                    validator.validate().then(function (status) {
                        if (status === 'Valid') {
                            new DismissModal(thisClass.addMembersModal.id).disable();
                            submitButton.setAttribute('data-kt-indicator', 'on');
                            submitButton.disabled = true;

                            let membersGroupsInput = thisClass.addMembersModal.querySelector('input[name=membersOrGroupsToAdd]');
                            let selectedMembersOrGroups = JSON.parse(membersGroupsInput.value);
                            for (const i in selectedMembersOrGroups) {
                                if(selectedMembersOrGroups[i]['uuid']){
                                    let tableRowInput = thisClass.datatableEl.querySelector('input[value="'+selectedMembersOrGroups[i]['uuid']+'"]');
                                    if(tableRowInput){
                                        tableRowInput.checked = true;
                                        tableRowInput.closest('tr').classList.remove('d-none', 'not-in-access-card');
                                    }
                                }
                            }
                            thisClass.afterAddOrRemoveEvents(datatable);

                            bootstrap.Modal.getOrCreateInstance(thisClass.addMembersModal).hide();
                            bootstrap.Modal.getOrCreateInstance(thisClass.modal, {}).show();
                            submitButton.setAttribute('data-kt-indicator', 'off');
                            submitButton.disabled = false;
                            new DismissModal(thisClass.addMembersModal.id).enable();
                            membersGroupsInput.__tagify.removeTags();
                        }
                    });
                }
            }

            submitButton.addEventListener('click', function (e) {
                // Prevent default button action
                e.preventDefault();
                // Validate form before submit
                submitForm(datatable);
            });

            form.addEventListener("submit", function(e) {
                // Prevent default button action
                e.preventDefault();
                // Validate form before submit
                submitForm(datatable);
            }, true);
        }
    }
    removeMemberOrGroupFromAccessCard(datatable){
        let thisClass = this;
        let removeMemberButtons = $(thisClass.datatableEl).find('.remove-member-from-access-card');
        removeMemberButtons.on('click', function() {
            let row = $(this).closest('tr');
            if(row.find('input[name=members\\[\\]]').length === 1){
                row.find('input[name=members\\[\\]]').prop('checked', false);
            } else {
                row.find('input[name=groups\\[\\]]').prop('checked', false);
            }
            row.addClass('d-none not-in-access-card');
            thisClass.afterAddOrRemoveEvents(datatable);
        });

        let removeAllMembersButtons = $(thisClass.datatableEl).find('.remove-all-members-from-access-card');
        removeAllMembersButtons.on('click', function() {
            let inputs = $(thisClass.form).find('tr input[name=members\\[\\]]');
            for (let i = 0; i < inputs.length; i++) {
                let row = $(inputs[i]).closest('tr');
                $(inputs[i]).prop('checked', false);
                row.addClass('d-none not-in-access-card');
            }
            thisClass.afterAddOrRemoveEvents(datatable);
        });
        let removeAllGroupsButtons = $(thisClass.datatableEl).find('.remove-all-groups-from-access-card');
        removeAllGroupsButtons.on('click', function() {
            let inputs = $(thisClass.form).find('tr input[name=groups\\[\\]]');
            for (let i = 0; i < inputs.length; i++) {
                let row = $(inputs[i]).closest('tr');
                $(inputs[i]).prop('checked', false);
                row.addClass('d-none not-in-access-card');
            }
            thisClass.afterAddOrRemoveEvents(datatable);
        });
    }
    afterAddOrRemoveEvents(datatable){
        let membersNotInAccessCard = datatable.rows('.not-in-access-card.d-none.is-member').data().toArray();
        let groupsNotInAccessCard = datatable.rows('.not-in-access-card.d-none.is-group').data().toArray();
        let membersInAccessCard = datatable.rows(':not(.not-in-access-card.d-none).is-member').data().toArray();
        let groupsInAccessCard = datatable.rows(':not(.not-in-access-card.d-none).is-group').data().toArray();

        let accessCardMembersSelected = this.modal.querySelector('#access_card_members_selected');
        if(accessCardMembersSelected){
            accessCardMembersSelected.innerText = membersInAccessCard.length;
        }
        let accessCardGroupsSelected = this.modal.querySelector('#access_card_groups_selected');
        if(accessCardGroupsSelected){
            accessCardGroupsSelected.innerText = groupsInAccessCard.length;
        }

        let addMembersToAccessCardButton = this.modal.querySelector('#addMembersToAccessCard');
        if((membersNotInAccessCard.length + groupsNotInAccessCard.length) === 0){
            addMembersToAccessCardButton.setAttribute('disabled', 'true');
        } else {
            addMembersToAccessCardButton.removeAttribute('disabled');
        }

        if(membersInAccessCard.length === 0){
            $(this.datatableEl).find('tr[data-section-name=members]').addClass('d-none');
        } else {
            $(this.datatableEl).find('tr[data-section-name=members]').removeClass('d-none');
        }
        if(groupsInAccessCard.length === 0){
            $(this.datatableEl).find('tr[data-section-name=groups]').addClass('d-none');
        } else {
            $(this.datatableEl).find('tr[data-section-name=groups]').removeClass('d-none');
        }

        let jQueryModal = $(this.modal);
        if((membersInAccessCard.length + groupsInAccessCard.length) === 0){
            jQueryModal.find('#members-and-groups-datatable_wrapper').hide();
            jQueryModal.find('#members-and-groups-datatable_no-results').addClass('d-flex flex-center flex-column').removeClass('d-none');
            jQueryModal.find('div[data-step="members-groups"] [data-kt-docs-table-filter="search-parent"]').addClass('d-none');
        } else {
            jQueryModal.find('#members-and-groups-datatable_wrapper').show();
            jQueryModal.find('#members-and-groups-datatable_no-results').removeClass('d-flex flex-center flex-column').addClass('d-none');
            jQueryModal.find('div[data-step="members-groups"] [data-kt-docs-table-filter="search-parent"]').removeClass('d-none');
        }
    }
    resetDatatable(){
        let addMembersToAccessCardButton = this.modal.querySelector('#addMembersToAccessCard');
        addMembersToAccessCardButton.removeAttribute('disabled');

        if(this.datatableIntance){
            let membersOrGroupInAccessCard = this.datatableIntance.rows(':not(.not-in-access-card.d-none)').data().toArray();
            for(let i in membersOrGroupInAccessCard){
                let node = $(this.datatableIntance.row(i).node());
                if(node.find('input[name=members\\[\\]]').length === 1){
                    node.find('input[name=members\\[\\]]').prop('checked', false);
                } else {
                    node.find('input[name=groups\\[\\]]').prop('checked', false);
                }
                node.addClass('d-none not-in-access-card');
            }
        }

        let jQueryModal = $(this.modal);
        jQueryModal.find('#members-and-groups-datatable_wrapper').hide();
        jQueryModal.find('#members-and-groups-datatable_no-results').addClass('d-flex flex-center flex-column').removeClass('d-none');
        jQueryModal.find('#div[data-step="members-groups"] [data-kt-docs-table-filter="search-parent"]').addClass('d-none');
    }
}
window.AccessCardMembersAndGroups = AccessCardMembersAndGroups;